// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f5b994ee","703":"96062a2e","787":"1c6699c6"}[chunkId] + ".chunk.js";
};